import { useEffect, useRef, useState } from 'react';
import { businessSendOutcome } from '../models/businessSendOutcome';
import { useSharedOnlyPolicy } from './useSharedOnlyPolicy';
export function useBusinessOutcomeFence(actor, kind, id) {
  const policy = useSharedOnlyPolicy();
  const key = `uzdpart360:business-outcome:${actor}:${kind}:${id}`;
  const currentKey = useRef(key); currentKey.current = key;
  const read = () => {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const saved = JSON.parse(raw);
      return typeof saved.message === 'string' ? saved : { message: 'Saved send outcome is unreadable. Do not send again.' };
    } catch { return { message: 'Saved send outcome is unreadable. Do not send again.' }; }
  };
  const [state, setState] = useState({ key, outcome: read() });
  useEffect(() => {
    const refresh = () => setState({ key, outcome: read() });
    window.addEventListener('business-send-updated', refresh); window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('business-send-updated', refresh); window.removeEventListener('storage', refresh); };
    // Reads are intentionally scoped to the captured actor/resource key.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  const enabled = policy.known && policy.enabled;
  // A rollback changes routing, not the outcome of an already-issued send/code.
  const outcome = state.key === key ? state.outcome : read();
  const capture = error => {
    if (!enabled) return null;
    const next = businessSendOutcome(error);
    if (!next) return null;
    if (currentKey.current !== key) return next;
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* keep this session fenced */ }
    setState({ key, outcome: next });
    return next;
  };
  return { outcome, capture };
}
